import styled from 'styled-components';

import { basicSmallTextStyle } from '@dreryk/react-components';

export const StyledNumericalDosageMedicineUnit = styled.div`
   ${basicSmallTextStyle};
   overflow: hidden;
   white-space: nowrap;
   text-overflow: ellipsis;
   max-width: 72px;
   margin-top: 8px;
`;
StyledNumericalDosageMedicineUnit.displayName = 'StyledNumericalDosageMedicineUnit';
